import React from "react";
import { Phone, Mail, Facebook, Instagram, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";

// TikTok icon (lucide has no TikTok as of v0.516) - inline SVG
const TikTok = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.5 6.75a5.75 5.75 0 0 1-4-1.6v9.2A6.2 6.2 0 1 1 9.3 8.15v3.05a3.15 3.15 0 1 0 2.2 3v-11h3.1a5.75 5.75 0 0 0 4.9 5.55v-2z"/>
  </svg>
);

export const Footer = () => (
  <footer id="footer" className="bg-brand-black text-white">
    <div className="container-mv py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <Logo dark />
        <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-md">
          Professional mobile tire service — Calgary and surrounding communities. We come to you: fast, honest, and equipped for the job.
        </p>
        <div className="mt-6 flex items-center gap-3">
          {[
            { icon: Facebook,  label: "Facebook",  href: "#" },
            { icon: Instagram, label: "Instagram", href: "#" },
            { icon: TikTok,    label: "TikTok",    href: "#" },
          ].map(({ icon: Icon, label, href }) => (
            <a key={label} href={href} aria-label={label} className="w-9 h-9 rounded-lg bg-white/10 hover:bg-brand-red flex items-center justify-center transition-colors">
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>

      <div>
        <div className="text-xs font-semibold tracking-widest text-white/50 uppercase">Quick Links</div>
        <ul className="mt-4 space-y-2 text-sm">
          {[["#services","Services"],["#why","Why Choose Us"],["#about","About"],["#service-area","Service Area"],["#faq","FAQ"],["#contact","Book Service"]].map(([h,l]) => (
            <li key={h}><a href={h} className="text-white/80 hover:text-brand-red transition-colors">{l}</a></li>
          ))}
        </ul>
      </div>

      <div>
        <div className="text-xs font-semibold tracking-widest text-white/50 uppercase">Contact</div>
        <ul className="mt-4 space-y-3 text-sm">
          <li><a href="tel:4034043515" className="inline-flex items-center gap-2 text-white/80 hover:text-brand-red"><Phone className="w-4 h-4 text-brand-red" /> 403-404-3515</a></li>
          <li><a href="mailto:mavtechtires@hotmail.com" className="inline-flex items-center gap-2 text-white/80 hover:text-brand-red"><Mail className="w-4 h-4 text-brand-red" /> mavtechtires@hotmail.com</a></li>
          <li className="inline-flex items-center gap-2 text-white/80"><MapPin className="w-4 h-4 text-brand-red" /> Calgary, Alberta</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container-mv py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <div>© {new Date().getFullYear()} Mavtech Mobile Tires. All rights reserved.</div>
        <div className="flex items-center gap-4">
          <a href="/admin/login" className="hover:text-brand-red transition-colors" data-testid="footer-admin-link">Admin</a>
          <span>Calgary · Airdrie · Chestermere · Cochrane · Okotoks</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
